import React from 'react';
import { Row, Col, Alert } from 'reactstrap';

class TrailerView extends React.Component {
  render() {
    const { trailers } = this.props;
    const imageSrc = `data:image/png;base64,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`;
    return (
      <Alert
        md={12}
        color='info'
        style={{
          width: '100%',
          marginTop: 10,
          padding: 5,
          backgroundColor: '#F2F3F4',
          borderColor: '#E5E7E9',
        }}
      >
        <Row>
          <Col md={'4'}>Trailer Type: {trailers.trailerType}</Col>
          <Col md={'4'}>Count: {trailers.count}</Col>

          <Col md={'3'}>Year: {trailers.year}</Col>

          <Col md={'1'}>
            <img
              alt={''}
              src={imageSrc}
              style={{
                cursor: 'pointer',
              }}
              onClick={this.props.onClick}
            />
          </Col>
          <Col md={'12'}>Notes: {trailers.notes}</Col>
        </Row>
      </Alert>
    );
  }
}

export default TrailerView;
